<template>

    <div class="mobile-sorting" :class="{ 'active': isActive }">

        <div
            class="item"
            :class="{ 'active': activeReference.toLowerCase() === 'default' }"
            @click.prevent="Bus.emit('toggle-sorting', 'default')"
        >{{ translations.text }}</div>

        <div
            class="item"
            :class="{ 'active': setActive(type) }"
            @click.prevent="emit('toggle-sorting', type.reference)"
            v-for="type in translations.types"
            v-show="showOption(type.text) || setActive(type)"
        >{{ type.text }}</div>

    </div>

</template>

<script>

export default {
//            v-show="this.activeTitles?.includes(type.text.toLowerCase())"

    name: 'MobileSorting',

    props: ['filter-data', 'translations'],

    data() {
        return {
            filters: null,
            isActive: false,
            activeReference: 'default',
            activeTitles: [],
        }
    },

    created() {
        this.filters = this.filterData;
        this.initFilters();
    },

    mounted() {

        this.Bus.on('toggle-mobile-sorting', (reference) => {

            console.log('-> toggle-mobile-sorting');

            this.isActive = ! this.isActive;

            if (this.isActive) {
                this.Bus.emit('set-popup-active-class');
                this.Bus.emit('hide-mobile-filters');
                this.Bus.emit('dock-header');
            } else {
                this.Bus.emit('set-popup-inactive-class');
            }
        });

        this.Bus.on('hide-mobile-sorting', (reference) => {
            this.isActive = false;
        });

        this.Bus.on('toggle-sorting', (reference) => {

            this.activeReference = reference;

            const sortReferenceTarget = document.querySelector('.filter-dropdown[data-filter-reference="' + this.translations.reference + '"]');
            const targetReference = this.activeReference === 'default' ? '' : reference;

            if (sortReferenceTarget) {
                sortReferenceTarget.setAttribute('data-selected-value', targetReference);
                this.Bus.emit('filter-change');
                this.isActive = false;
            }

        });

        this.Bus.on('update-sorting', (data) => {
            this.filters = data;
            this.initFilters();
        });
    },

    methods: {

        initFilters() {
            const selectedFilters = Object.values(this.filters.selectedFilters);

            this.activeTitles = this.filters.items.map(item => item.title.toLowerCase());

            if (selectedFilters.length > 0) {
                selectedFilters.forEach(value => {
                    this.activeReference = Object.keys(value)[0];
                });
            }
        },

        setActive(type) {
            return this.activeReference.toLowerCase() === type.reference.toLowerCase();
        },

        showOption(text) {
            return this.activeTitles?.includes(text.toLowerCase())
        },
    }
};

</script>
